/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2022-08-12 14:21:31
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';
import BsyAddress from '../../BsyAddress';
import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterAddress extends BsyFilterBase {

    DEFAULT_SIZE = {
        single: {
            minSizeX: 20,
            minSizeY: 6
        },
        double: {
            minSizeX: 15,
            minSizeY: 8
        }
    }
    ITEM_WIDTH = {
        NO_WRAP: {
            width4province: "33.3%",
            width4city: "33.3%",
            width4district: "33.3%"
        },
        WRAP: {
            width4province: "100%",
            width4city: "50%",
            width4district: "50%"
        }
    }

    constructor(props) {
        super({
            customCls: "fui_dash_address",
            minRow: 8,
            onStopEdit: null,
            ...props
        })

        this.dashText = null;
    }



    _doWrap = (e) => {

        if (e) {
            this.options.wrap = true
            this.dashText.options = { ...this.dashText.options, ...this.ITEM_WIDTH.WRAP }
        } else {
            this.options.wrap = false
            this.dashText.options = { ...this.dashText.options, ...this.ITEM_WIDTH.NO_WRAP }
        }

        // e ? (this.options.wrap = true,
        //     this.dashText.options = { ...this.dashText.options,...this.ITEM_WIDTH.WRAP}) : (this.options.wrap = false,
        //         t.extend(this.dashText.options, this.ITEM_WIDTH.NO_WRAP))
        this.setState({})
        // this.dashText.rebuild()
    }


    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.ALL, BsyConfig().CONST.FILTER_METHOD.NIN, BsyConfig().CONST.FILTER_METHOD.EP, BsyConfig().CONST.FILTER_METHOD.NEP]
    }

    _getMethodName = (t) => {
        var e = {};
        e[BsyConfig().CONST.FILTER_METHOD.ALL] = {
            name: React.language("filter.method.all.address")
        }
        e[BsyConfig().CONST.FILTER_METHOD.NIN] = {
            name: React.language("filter.method.nin.address")
        }
        e[BsyConfig().CONST.FILTER_METHOD.EP] = {
            name: React.language("filter.method.ep")
        }
        e[BsyConfig().CONST.FILTER_METHOD.NEP] = {
            name: React.language("filter.method.nep")
        }
        return e[t].name
    }


    getValue = () => {
        if (this.dashText) {
            let e = this.dashText.getValue()
            return e;
        }
    }

    getContext = (e) => {
        this.dashText = e;
    }

    renderCont = () => {
        let e = this
        let i = this.options;

        let val = this.getMiddleValue();
        switch (e.method) {
            case BsyConfig().CONST.FILTER_METHOD.ALL:
            case BsyConfig().CONST.FILTER_METHOD.NIN:

                return <BsyAddress
                    getContext={this.getContext}
                    theme={this.props.theme}
                    format={i.format}
                    value={val}
                    customCls={(i.height > i.minRow ? 'wrap' : '')}
                    onStopEdit={(t) => {
                        e.value = e.getValue()
                        BsyUtils.applyFunc(this, this.props.onStopEdit, [{
                            value: e.getValue(),
                            method: e.method,
                            valueMode: i.valueMode
                        }, i], !1)
                    }}
                ></BsyAddress>
 
            default:
                break;
        }
    }
    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

